import React, { useEffect, useState } from 'react';
import { useNavigate, useHref } from 'react-router-dom';
import '../../styles/Admin/adminStyles.css';
import { Routes, Route, Link } from 'react-router-dom';

// 👇️ screens
import AdminLogin from './AdminLogIn';
import AdminSignUp from './AdminSignUp';
import AdminResetPassword from './AdminResetPassword';
import AdminDashboard from './AdminDashboard';

export default function AdminPage({
    alumni,
    events,
    announcements,
    jobPosts,
    fetchAnnouncements,
    fetchAllAlumni,
    fetchEvents,
    fetchJobPosts,
}) {
    const [adminLoggedIn, setAdminLoggedIn] = useState(false);
    const [adminData, setAdminData] = useState({});
    const [screen, setScreen] = useState('Login');
    const navigate = useNavigate();

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';

        // 👇️ going to check if admin logged in.
        fetch('/admin')
            .then(async (result) => {
                let response = await result.json();
                console.log('\nresponse:', response);
                if (response?.msg == "don't redirect") setScreen('Login');
                else {
                    if (response?.admin) {
                        let data = response?.admin;
                        setAdminData(data);
                    }
                    setScreen('Main Page');
                }
            })
            .catch((error) => {
                console.log('admin error:', error?.message, '\n', error);
            });
    }, []);

    // 👇️ return screen based on whether admin is loggedin or not.
    const getScreen = () => {
        if (screen === 'Main Page')
            return (
                <AdminDashboard
                    setScreen={setScreen}
                    adminData={adminData}
                    alumni={alumni}
                    events={events}
                    announcements={announcements}
                    jobPosts={jobPosts}
                    fetchJobPosts={fetchJobPosts}
                    fetchAnnouncements={fetchAnnouncements}
                    fetchAllAlumni={fetchAllAlumni}
                    fetchEvents={fetchEvents}
                />
            );
        else if (screen === 'Signup') return <AdminSignUp setScreen={setScreen} />;
        // else if (screen === 'reset-password') return <AdminResetPassword setScreen={setScreen} />;
        else return <AdminLogin setScreen={setScreen} adminData={adminData} />;
    };

    return getScreen();
}
